import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const houseRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
]

export const houseRentEstateFeatures = () => estateFeatures(houseRentEstateFeaturesList)

export const createHouseRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(houseRentEstateFeaturesList, label, className)

export const houseRentBuildingTypeOptions = [
  BuildingTypeOption.SINGLE_FAMILY_HOUSE,
  BuildingTypeOption.MID_TERRACE_HOUSE,
  BuildingTypeOption.END_TERRACE_HOUSE,
  BuildingTypeOption.MULTI_FAMILY_HOUSE,
  BuildingTypeOption.BUNGALOW,
  BuildingTypeOption.FARMHOUSE,
  BuildingTypeOption.SEMIDETACHED_HOUSE,
  BuildingTypeOption.VILLA,
  BuildingTypeOption.CASTLE_MANOR_HOUSE,
  BuildingTypeOption.SPECIAL_REAL_ESTATE,
  BuildingTypeOption.OTHER,
]
